import { useMutation } from "@tanstack/react-query";
import axiosInstance from "./axios";
import { PurchaseProductsResponseT } from "../types/purchaseTypes";
import { PurchaseSchemaT } from "../types/schema/purchaseEntery";



export const useDeletePurchaseEntry = () => {
  return useMutation({
    mutationKey: ["useDeletePurchaseEntry"],
    mutationFn: async (purchaseEntryId: string | undefined) => {
      const { data } = await axiosInstance.delete(
        `/purchase-entry/${purchaseEntryId}`,
      );
      return data;
    },
  });
};

export const useAddPurchaseEntry = () => {
  return useMutation({
    mutationKey: ["useAddPurchaseEntry"],
    mutationFn: async (postData: PurchaseSchemaT) => {
      const { data } = await axiosInstance.post("/purchase-entry", postData);
      return data as PurchaseProductsResponseT[];
    },
  });
};

export const useUpdatePurchaseEntry = () => {
  return useMutation({
    mutationKey: ["useUpdatePurchaseEntry"],
    mutationFn: async (postData: PurchaseSchemaT) => {
      const { data } = await axiosInstance.put("/purchase-entry", postData);
      return data as PurchaseProductsResponseT[];
    },
  });
};

export const checkPurchaseNumberExists = async (
  purchaseNumber: string,
  vendorId: number,
  signal?: AbortSignal,
): Promise<boolean> => {
  if (!purchaseNumber.trim() || vendorId <= 0) return false;
  const { data } = await axiosInstance.get<boolean>(
    "/purchase-entry/purchaseNumberValidator",
    { params: { purchaseNumber: purchaseNumber.trim(), vendorId }, signal },
  );
  return data;
};
